import { updatesItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            最新动态
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            站点快讯
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            内容更新、读者投稿、站点公告——不错过每一个重要时刻
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300/60"></div>

          <div className="space-y-0">
            {updatesItems.map((item, index) => (
              <div key={index} className="relative flex items-start gap-4 md:gap-6 pb-6 md:pb-7 last:pb-0 pl-10 md:pl-14">
                <div className={`absolute left-4 md:left-6 w-3 h-3 rounded-full border-2 border-background-50 -translate-x-1/2 mt-1.5 z-10 ${
                  index === 0 ? 'bg-primary-500' : 'bg-secondary-400'
                }`}></div>

                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-1">
                    <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">
                      {item.date}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                      item.tag === '每日更新'
                        ? 'bg-primary-100 text-primary-700'
                        : item.tag === '读者来稿'
                        ? 'bg-accent-100 text-accent-700'
                        : item.tag === '站点公告' || item.tag === '栏目上新'
                        ? 'bg-green-100 text-green-700'
                        : item.tag === '合作动态'
                        ? 'bg-secondary-100 text-secondary-700'
                        : 'bg-secondary-100 text-secondary-600'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-8 md:mt-10">
          <span className="text-xs text-foreground-500">
            显示最近 9 条动态，每日持续更新中
          </span>
        </div>
      </div>
    </section>
  );
}